module.exports = {
	"name": "solid-client",
	"version": "0.24.3",
	"description": "Common library for writing Solid read-write-web applications",
	"main": "./lib/index.js",
	"files": [
		"config.js",
		"lib",
		"dist"
	],
	"scripts": {
		"build-lib": "babel src -d lib",
		"build-full": "webpack --progress --config webpack.config.js --output-filename solid-client-full.js",
		"build-with-rdflib": "webpack --progress --colors --optimize-minimize --optimize-occurrence-order --optimize-dedupe --config webpack.config.js",
		"build-without-rdflib": "webpack --progress --colors --optimize-minimize --optimize-occurrence-order --optimize-dedupe --config webpack-no-rdflib.config.js",
		"build-qunit-resources": "npm run clean && mkdir -p dist/resources && npm run build-full && browserify -r ./test/resources/profile-minimal.js:test-minimal-profile -o dist/resources/test-minimal-profile.js && browserify -r ./test/resources/profile-private.js:test-minimal-prefs -o dist/resources/test-minimal-prefs.js",
		"build": "npm run clean && mkdir dist && npm run build-lib && npm run build-with-rdflib && npm run build-without-rdflib",
		"clean": "rm -rf dist/",
		"standard": "standard src/*",
		"tape": "tape test/unit/*.js",
		"test": "npm run standard && npm run tape",
		"qunit": "npm run build-qunit-resources && open test/integration/index.html",
		"preversion": "npm test",
		"postversion": "git push --follow-tags",
		"prepublish": "npm run test && npm run build"
	},
	"repository": {
		"type": "git",
		"url": "https://github.com/solid/solid-client"
	},
	"keywords": [
		"solid",
		"decentralized",
		"web",
		"rdf",
		"ldp",
		"linked",
		"data"
	],
	"author": "Andrei Sambra <andrei@fcns.eu>",
	"maintainers": [
		{
			"name": "Dmitri Zagidulin",
			"url": "https://github.com/dmitrizagidulin/"
		}
	],
	"license": "MIT",
	"bugs": {
		"url": "https://github.com/solid/solid-client/issues"
	},
	"homepage": "https://github.com/solid/solid-client",
	"dependencies": {
		"rdflib": "^0.13.0",
		"shorthash": "0.0.2",
		"solid-auth-oidc": "^0.1.2",
		"solid-auth-tls": "0.0.4",
		"solid-namespace": "^0.1.0",
		"solid-permissions": "^0.5.1",
		"solid-web-client": "^0.3.2"
	},
	"devDependencies": {
		"babel-cli": "^6.18.0",
		"babel-loader": "^6.2.10",
		"babel-preset-es2015": "^6.18.0",
		"json-loader": "^0.5.4",
		"nock": "^9.0.2",
		"qunit": "^0.9.0",
		"sinon": "^2.1.0",
		"standard": "^5.4.1",
		"tape": "^4.4.0",
		"webpack": "^1.13.1"
	},
	"standard": {
		"globals": [
			"$rdf",
			"SolidClient",
			"tabulator",
			"QUnit"
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 173
// module chunks = 0